import { createContext, useContext } from "react";

import { Locale } from "date-fns";

import { Locale as AELocale, Currency } from "@/constants";

type CurrencyFormatter = (amount: number, currency?: Currency) => string;
export type DateFormatter = (date: Date | string, dateFormat: string) => string;
type DateRangeFormatter = (
  start: Date | string | undefined,
  end: Date | string | undefined,
  dateFormat: string,
  options?: { allowSameDay?: boolean }
) => string;
type NumberFormatter = (n: number) => string;
type PrecisionNumberFormatter = (n: number, precision?: number) => string;

type i18nContextType = {
  locale?: Locale;
  language: AELocale;
  currency: Currency;
  formatCurrency: CurrencyFormatter;
  formatDate: DateFormatter;
  formatDateRange: DateRangeFormatter;
  formatNumber: NumberFormatter;
  formatPercent: PrecisionNumberFormatter;
  abbreviateNumber: PrecisionNumberFormatter;
  abbreviateCurrency: NumberFormatter;
};

export const i18nContext = createContext<i18nContextType>(
  {} as i18nContextType
);

export const useI18n = () => useContext(i18nContext);
